import React from "react";
import { useLang } from "@/context/LanguageContext";
import { GMOAA } from "@/constants/testIds";

const photos = {
  office_bearer_1: "https://images.unsplash.com/photo-1758691463582-11aea602cd4a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwyfHxpbmRpYW4lMjBkb2N0b3IlMjBwb3J0cmFpdCUyMGhvc3BpdGFsJTIwbWVkaWNhbCUyMG9mZmljZXxlbnwwfHx8fDE3OTEyNzM1Njd8MA&ixlib=rb-4.1.0&q=85",
  office_bearer_2: "https://images.unsplash.com/photo-1758691461513-88a0aef72160?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwzfHxpbmRpYW4lMjBkb2N0b3IlMjBwb3J0cmFpdCUyMGhvc3BpdGFsJTIwbWVkaWNhbCUyMG9mZmljZXxlbnwwfHx8fDE3OTEyNzM1Njd8MA&ixlib=rb-4.1.0&q=85",
  office_bearer_3: "https://images.unsplash.com/photo-1758691462651-611d730c5272?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBkb2N0b3IlMjBwb3J0cmFpdCUyMGhvc3BpdGFsJTIwbWVkaWNhbCUyMG9mZmljZXxlbnwwfHx8fDE3OTEyNzM1Njd8MA&ixlib=rb-4.1.0&q=85",
  office_bearer_4: "https://images.unsplash.com/photo-1758691463384-771db2f192b3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHw0fHxpbmRpYW4lMjBkb2N0b3IlMjBwb3J0cmFpdCUyMGhvc3BpdGFsJTIwbWVkaWNhbCUyMG9mZmljZXxlbnwwfHx8fDE3OTEyNzM1Njd8MA&ixlib=rb-4.1.0&q=85",
};

export const OfficeBearerCard = ({ bearer }) => {
  const { tf } = useLang();
  const abs = (u) => (u ? (u.startsWith("http") ? u : `${process.env.REACT_APP_BACKEND_URL}${u}`) : "");
  const src = bearer.photo_url ? abs(bearer.photo_url) : (photos[bearer.photo_key] || photos.office_bearer_1);
  return (
    <div
      data-testid={`${GMOAA.bearerCard}-${bearer.order ?? 0}`}
      className="group overflow-hidden rounded-xl border border-gmoaa-border-subtle bg-white transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
    >
      <div className="relative h-52 overflow-hidden bg-gmoaa-green-light">
        <img
          src={src}
          alt={tf(bearer, "name")}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-gmoaa-green/90 to-transparent px-4 py-3">
          <span className="rounded-full bg-gmoaa-gold px-2.5 py-0.5 text-xs font-semibold text-gmoaa-green">
            {tf(bearer, "role")}
          </span>
        </span>
      </div>
      <div className="p-4">
        <p className="font-serif text-lg font-semibold text-gmoaa-text-dark">{tf(bearer, "name")}</p>
        <p className="text-sm text-gmoaa-text-muted">{tf(bearer, "role")}</p>
      </div>
    </div>
  );
};
